import { render, staticRenderFns } from "./IntegrationHooks.vue?vue&type=template&id=141588dc&"
import script from "./IntegrationHooks.vue?vue&type=script&lang=js&"
export * from "./IntegrationHooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports